import { render, staticRenderFns } from "./DeleteFileDialog.vue?vue&type=template&id=3ab79c0a&scoped=true&"
import script from "./DeleteFileDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab79c0a",
  null
  
)

export default component.exports